import type { SunmiPrinterModuleType } from './SunmiPrinter.types'

const SunmiPrinter: SunmiPrinterModuleType = {
    getDefaultPrinterInfo: async () => null,
    getDefaultPrinterStatus: async () => null,
    sendEscPosCommands: async () => {
        throw new Error('Sunmi printer integration is only available on Android.')
    },
}

export default SunmiPrinter
